import { services } from '@billow/js-helpers'

export default class User {

  constructor(user = {}) {
    this.id = user.id || null
    this.name = user.name || ''
    this.email = user.email || ''
    this.mobile = user.mobile || ''
    this.password = user.password || ''
    this.password_confirmation = user.password_confirmation || ''
    this.profile_picture = user.profile_picture || null
    this.profile_picture_url = user.profile_picture_url || null
    this.name_components = user.name_components || {}
    this.two_factor_is_setup = user.two_factor_is_setup || false
  }

  static commonMutations() {
    return {
      updateName: (state, name) => state.user.name = name,
      updateEmail: (state, email) => state.user.email = email,
      updateMobile: (state, payload) => state.user.mobile = payload,
      setUser: (state, user) => state.user = new User(user),
      clearUser: (state) => state.user = new User(),
      setProfilePictureUrl: (state, url) => state.user.profile_picture_url = url,
    }
  }

  static authMutations() {
    return {
      updatePassword: (state, payload) => state.user.password = payload,
      updatePasswordConfirmation: (state, payload) => state.user.password_confirmation = payload,
      deleteToken: (state) => {
        state.user = new User()
      },
      disable2Fa: (state) => state.user.two_factor_is_setup = false,
      set2FaSecret: (state, payload) => state.user.two_factor_secret = payload,
      set2Fa: (state) => state.user.two_factor_is_setup = true,
    }
  }

}
